import { render } from "./ManageVendors.vue?vue&type=template&id=30d11484&scoped=true"
import script from "./ManageVendors.vue?vue&type=script&lang=js"
export * from "./ManageVendors.vue?vue&type=script&lang=js"

import "./ManageVendors.vue?vue&type=style&index=0&id=30d11484&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d11484"]])

export default __exports__